import { render, staticRenderFns } from "./UserDashboard.vue?vue&type=template&id=76f5280b&scoped=true&"
import script from "./UserDashboard.vue?vue&type=script&lang=js&"
export * from "./UserDashboard.vue?vue&type=script&lang=js&"
import style0 from "./UserDashboard.vue?vue&type=style&index=0&id=76f5280b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f5280b",
  null
  
)

export default component.exports